export default __webpack_public_path__ + "static/header_logo-cfc4a6051cb951c02bebbc7b445cf184.png";